const sign = {
    state: {},
    mutations: {},
    actions: {}
}

export default sign


// WEBPACK FOOTER //
// ./src/base/vuex/modules/sign.js